/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GET_PLAN_TYPE_DATA = 'GET_PLAN_TYPE_DATA';
export const REFRESH_MANUFACTURE_SUMMARY_DISPLAY =
  'REFRESH_MANUFACTURE_SUMMARY_DISPLAY';
export const IS_LOADING_MANNUFACTURER_SUMMERY =
  'IS_LOADING_MANNUFACTURER_SUMMERY';
export const GET_DRAMS_INVOICE_START_QUARTER_VALUE =
  'GET_DRAMS_INVOICE_START_QUARTER_VALUE';
export const GET_EARLIEST_QTR_DRUG_VALUE = 'GET_EARLIEST_QTR_DRUG_VALUE';
export const SET_BALANCE_THRESH = 'SET_BALANCE_THRESH';
export const SET_SEARCH_INPUT_MANUFACTURER_SUMMRARY =
  'SET_SEARCH_INPUT_MANUFACTURER_SUMMRARY';
export const GET_MANUFACTURER_LIST_MANUFACTURER_SUMMARY =
  'GET_MANUFACTURER_LIST_MANUFACTURER_SUMMARY';
export const GET_RESULT_MANUFACTURER_SUMMARY =
  'GET_RESULT_MANUFACTURER_SUMMARY';

export const GET_DISPUTE_AMOUNT_FOR_QUARTER = 'GET_DISPUTE_AMOUNT_FOR_QUARTER';
export const REFRESH_MANUFACTURE_SUMMARY = 'REFRESH_MANUFACTURE_SUMMARY';
